const axios = require('axios');

async function buildHeaders(configUrl = '/v1/tenantconfiguration/passthrough') {
  const token = sessionStorage.getItem('token');
  const tenant = sessionStorage.getItem('tenant');

  const headers = {
    'IC-USER-CLIENT': Buffer.from(tenant).toString('base64'),
    'X-IC-ACCESS-TOKEN': token
  };

  if (sessionStorage.getItem('tokenType') === 'bearer') {
    delete headers['X-IC-ACCESS-TOKEN'];
    headers['Authorization'] = `Bearer ${token}`;
  }

  let baseUrl = null;

  try {
    const configResponse = await fetch(configUrl, {
      headers: headers
    });

    if (configResponse.ok) {
      const config = await configResponse.json();
      if (config.passthroughApiKey) {
        headers['X-API-KEY'] = config.passthroughApiKey;
      }
      if (config.passthroughApiBaseUrl) {
        baseUrl = config.passthroughApiBaseUrl;
      }
    } else {
      console.warn('Config API returned status:', configResponse.status);
    }
  } catch (e) {
    console.error('Error loading config from API:', e);
  }

  return { headers, baseUrl };
}

class PassthroughApi {
  async getPassthroughFunds(filter = {}) {
    const { headers, baseUrl } = await buildHeaders();
    const url = `${baseUrl}/fundMappings/passthroughFunds`;

    try {
      const response = await axios.get(url, {
        headers,
        skipRequestSource: true
      });
      let data = response.data.results;

      if (filter.passthroughFundId) {
        const search = filter.passthroughFundId
          .replace(/\*/g, '')
          .toLowerCase();
        data = data.filter(item => item.name?.toLowerCase().includes(search));
      }

      return { data, total: data.length };
    } catch (error) {
      return { data: [], total: 0 };
    }
  }

  async getFundMappingForFund(filter) {
    const { headers, baseUrl } = await buildHeaders();
    const url = `${baseUrl}/fundMappings?icFundId=${encodeURIComponent(
      filter.icFundId
    )}`;

    try {
      const response = await axios.get(url, {
        headers,
        skipRequestSource: true
      });
      return { data: [{ id: 0, ...response.data }], total: 1 };
    } catch (error) {
      return { data: [], total: 0 };
    }
  }

  async createFundMapping(icFundId, ptFundId) {
    const { headers, baseUrl } = await buildHeaders();
    const url = `${baseUrl}/fundMappings?icFundId=${encodeURIComponent(
      icFundId
    )}&ptFundId=${encodeURIComponent(ptFundId)}`;

    try {
      const response = await axios.post(
        url,
        {},
        { headers, skipRequestSource: true }
      );
      return response.data;
    } catch (error) {
      return null;
    }
  }

  async deleteFundMapping(fundMappingId) {
    const { headers, baseUrl } = await buildHeaders();
    const url = `${baseUrl}/fundMappings/${fundMappingId}`;

    try {
      const response = await axios.delete(url, {
        headers,
        skipRequestSource: true
      });
      return response.data;
    } catch (error) {
      return null;
    }
  }
}

export default PassthroughApi;
